var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempChecker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 61.902,
    viewBox: "0 0 55 61.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.949,
    y1: 1.133,
    x2: 0.459,
    y2: 0.395,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0dff5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.441,
    y1: 0.488,
    x2: 0.734,
    y2: -0.415,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9197c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6965b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.463,
    y1: 1.469,
    x2: 0.495,
    y2: 0.395,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4b3c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.496,
    y1: -0.077,
    x2: 0.513,
    y2: 0.531,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.535,
    y1: 0.018,
    x2: 0.472,
    y2: 0.766,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.763,
    y1: -0.208,
    x2: 0.549,
    y2: 0.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.517,
    y1: 0.705,
    x2: 0.394,
    y2: 2.861,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#74c1ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43a7b3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190",
    transform: "translate(-29 -538.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165",
    transform: "translate(29 539.286)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M27.5,0A27.663,27.663,0,0,1,55,27.823,27.663,27.663,0,0,1,27.5,55.646,27.663,27.663,0,0,1,0,27.823,27.663,27.663,0,0,1,27.5,0Z",
    transform: "translate(0 3.037)",
    fill: "#d2d5ec"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M437.828,439.12s1.745,6.919,0,13.132-3.908,14.191-1.744,22.31a12.871,12.871,0,0,0,9.7.918c5.513-1.623,3.978-6.354,4.257-9.813s.7-13.485,4.815-21.11,5.652-10.1,6.141-12.5Z",
    transform: "translate(-420.679 -415.454)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M451.573,488.019a16.091,16.091,0,0,1-.743-16.261c2.758-5.631,5.448-7.507,7.051-8.122a71.248,71.248,0,0,0-2.233,14.629C455.374,481.687,456.871,486.347,451.573,488.019Z",
    transform: "translate(-426.284 -428.052)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M462.807,432.06a9.321,9.321,0,0,1-.4,1.395c-.062.163-.123.328-.19.5-.273.689-.642,1.463-1.122,2.4-.748,1.451-1.764,3.3-3.143,5.835-2.886,3.395-8.183,6.585-17.54,4.23h-.005c.005-.225.005-.451,0-.672a32.261,32.261,0,0,0-.307-4.072.4.4,0,0,0-.011-.084c-.028-.226-.061-.441-.1-.644-.005-.022-.005-.045-.011-.073-.022-.118-.039-.237-.061-.344-.151-.887-.285-1.406-.285-1.406Z",
    transform: "translate(-422.491 -415.454)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M437.828,439.12s1.745,6.919,0,13.132-3.908,14.191-1.744,22.31a12.871,12.871,0,0,0,9.7.918c5.513-1.623,3.978-6.354,4.257-9.813s.7-13.485,4.815-21.11,5.652-10.1,6.141-12.5Z",
    transform: "translate(-420.679 -415.454)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M442.867,439.7a17.135,17.135,0,0,1,.628,10.8c-1.577,5.318-5.813,17.08-4.382,27.806",
    transform: "translate(-422.159 -418.501)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M458.068,463.147c-2.084,1.027-6.957,4.357-8.528,13.51-.933,5.434.47,8.936,2.25,11.131",
    transform: "translate(-426.389 -427.857)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M438,405.292l31.76-.861a2.04,2.04,0,0,1,2.084,2.052V420.52a2.385,2.385,0,0,1-1.777,2.318c-5.744,1.485-23.444,6.057-23.623,6.035C446.226,428.847,438.479,405.087,438,405.292Z",
    transform: "translate(-421.823 -404.43)",
    fill: "url(#linear-gradient-4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M489.848,404.43l-2.361.064a2.166,2.166,0,0,1,1.663,2.112v14.88a2.545,2.545,0,0,1-.751,1.8l1.755-.454a2.385,2.385,0,0,0,1.777-2.318V406.483A2.04,2.04,0,0,0,489.848,404.43Z",
    transform: "translate(-441.915 -404.43)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M471.846,406.481v3.1c0-3.807-4.449-3.152-4.449-3.152l-26.372,1.107-1.826.559a12.673,12.673,0,0,0-1.195-2.8l31.753-.864A2.044,2.044,0,0,1,471.846,406.481Z",
    transform: "translate(-421.827 -404.43)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M438,405.292l31.76-.861a2.04,2.04,0,0,1,2.084,2.052V420.52a2.385,2.385,0,0,1-1.777,2.318c-5.744,1.485-23.035,5.829-23.214,5.807C446.635,428.618,438.479,405.087,438,405.292Z",
    transform: "translate(-421.823 -404.43)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1.242
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M489.848,404.43l-2.361.064a2.166,2.166,0,0,1,1.663,2.112v14.88a2.545,2.545,0,0,1-.751,1.8l1.755-.454a2.385,2.385,0,0,0,1.777-2.318V406.483A2.04,2.04,0,0,0,489.848,404.43Z",
    transform: "translate(-441.915 -404.43)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M433.574,407.846l-2.124,18.889a2.424,2.424,0,0,0,2.39,2.709h9.414a2.061,2.061,0,0,0,2.036-2.28l-1.966-19.538a1.948,1.948,0,0,0-1.929-1.763h-5.627A2.219,2.219,0,0,0,433.574,407.846Z",
    transform: "translate(-419.16 -405.002)",
    fill: "url(#linear-gradient-6)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M434.6,429.066a1.268,1.268,0,0,1-.962-.436,1.3,1.3,0,0,1-.319-1.016l2.124-18.889a1.1,1.1,0,0,1,1.085-.98h5.627a.824.824,0,0,1,.819.748l1.966,19.538a.937.937,0,0,1-.235.726.915.915,0,0,1-.69.31Z",
    transform: "translate(-419.922 -405.752)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M433.574,407.846l-2.124,18.889a2.424,2.424,0,0,0,2.39,2.709h9.414a2.061,2.061,0,0,0,2.036-2.28l-1.966-19.538a1.948,1.948,0,0,0-1.929-1.763h-5.627A2.219,2.219,0,0,0,433.574,407.846Z",
    transform: "translate(-419.16 -405.002)",
    fill: "none",
    stroke: "#591c87",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M438.317,424.233l.647-11.79H443.9l.088,11.79Z",
    transform: "translate(-421.954 -407.627)",
    fill: "url(#linear-gradient-7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempChecker);
export default __webpack_public_path__ + "static/media/temp_checker.0035d05a31d1adc03b440122c612785e.svg";
export { ForwardRef as ReactComponent };